
/* ── Datos: Productos ── */
const PRODUCTS = [
  { id:1,  name:'Harbour Work Shirt',    price:'110,00 €', raw:110,  color:'Índigo',      colors:['#1a2744','#e8e0d0'],           img:'pr1',  desc:'Camisa de trabajo en denim de alta calidad con corte relajado y detalles artesanales.',           tag:null,         story:'Inspirada en las camisas de los pescadores ibicencos de los años 70.' },
  { id:2,  name:'Drift Chino',           price:'95,00 €',  raw:95,   color:'Sand',         colors:['#c2b280','#1a1a1a'],           img:'pr2',  desc:'Pantalón chino de corte recto en algodón orgánico. Versatilidad para cualquier ocasión.',      tag:null,         story:'Construido en algodón pima peruano de comercio justo.' },
  { id:3,  name:'Signature Hoodie',      price:'120,00 €', raw:120,  color:'Sage',         colors:['#708238','#1a1a1a','#9b9b9b'], img:'pr3',  desc:'Sudadera oversized en algodón premium. Diseño atemporal para todas las estaciones.',            tag:'New',        story:'Nuestro tejido exclusivo de rizo francés de 380 gsm.' },
  { id:4,  name:'Loom Tee',              price:'45,00 €',  raw:45,   color:'Blanco',       colors:['#f8f6f3','#1a1a1a'],           img:'pr4',  desc:'Camiseta de algodón premium tejido en telar artesanal. La base perfecta de cualquier look.',   tag:null,         story:'Tejida a mano en Portugal por maestros tejedores.' },
  { id:5,  name:'Villa Blanca Dress',    price:'185,00 €', raw:185,  color:'Arena',        colors:['#e3dcd1','#f4f2ef','#c2a88a'], img:'pr5',  desc:'Vestido en lino orgánico mediterráneo con espalda abierta y lazos artesanales.',               tag:'Bestseller',  story:'Inspirada en las fincas encaladas de Ibiza, celebra la arquitectura mediterránea. Edición limitada.' },
  { id:6,  name:'Terra Wide-Leg',        price:'165,00 €', raw:165,  color:'Desert Sand',  colors:['#c8a882','#f0ece5'],           img:'pr6',  desc:'Pantalón wide-leg en lino plisado. Silueta arquitectónica que fluye con el movimiento.',        tag:null,         story:'Silhouette desarrollada en colaboración con la escultora Marta Vidal.' },
  { id:7,  name:'Raffia Solstice Hat',   price:'120,00 €', raw:120,  color:'Natural',      colors:['#c8a26a'],                    img:'pr7',  desc:'Sombrero de rafia artesanal con bordes sin rematar. Edición limitada del verano.',              tag:'Limited',    story:'Tejido a mano por artesanas de San Carlos, Ibiza.', cat:'accessory' },
  { id:8,  name:'Form Sandal',           price:'210,00 €', raw:210,  color:'Obsidian',     colors:['#1a1a1a','#c8a882'],           img:'pr8',  desc:'Sandalia escultural en cuero de curtido vegetal. Diseño de punta cuadrada y tira fina.',       tag:null,         story:'Fabricadas en un pequeño taller familiar de Menorca.', cat:'accessory' },
  { id:9,  name:'Drift Oversized Shirt', price:'165,00 €', raw:165,  color:'Sage',         colors:['#708238','#f4f2ef'],           img:'pr9',  desc:'Camisa oversized en lino suave. Para los días sin prisa, entre el mar y la montaña.',          tag:'New',        story:'El lino irlandés más suave de nuestra colección SS/25.', cat:'clothing' },
  { id:10, name:'Costa Tote Bag',        price:'85,00 €',  raw:85,   color:'Natural',      colors:['#c8a26a','#f4f2ef'],           img:'pr-tote',   desc:'Bolso tote de rafia trenzada a mano con asa de cuero vegetal. Perfecto para la playa y la ciudad.', tag:'New',   story:'Trenzado a mano por artesanas de la cooperativa de San Carlos.', cat:'accessory' },
  { id:11, name:'Mar Sunglasses',        price:'145,00 €', raw:145,  color:'Tortoise',     colors:['#8B6914','#1a1a1a'],           img:'pr-sun',    desc:'Gafas de sol de acetato bio con lentes polarizadas. Montura de inspiración vintage años 70.',   tag:null,    story:'Fabricadas en Italia con acetato de origen vegetal. Protección UV400.', cat:'accessory' },
  { id:12, name:'Ibiza Scarf',           price:'65,00 €',  raw:65,   color:'Terracotta',   colors:['#c67a4a','#f4f2ef','#708238'], img:'pr-scarf',  desc:'Pañuelo oversize de algodón orgánico con tinte natural de arcilla ibicenca.',                   tag:'Limited', story:'Teñido a mano con arcilla roja de la costa norte de Ibiza.', cat:'accessory' },
  { id:13, name:'Dalias Bracelet Set',   price:'48,00 €',  raw:48,   color:'Gold',         colors:['#C5A55A','#E8E0D0'],           img:'pr-brace',  desc:'Set de tres pulseras finas de latón reciclado bañadas en oro de 18k. Hechas a mano en Ibiza.', tag:'Bestseller', story:'Cada pulsera lleva grabado el nombre de una cala ibicenca.', cat:'accessory' },
  { id:14, name:'Piedra Ring',           price:'72,00 €',  raw:72,   color:'Silver',       colors:['#C0C0C0','#C5A55A'],           img:'pr-ring',   desc:'Anillo de plata 925 reciclada con piedra natural de cuarzo rosa. Pieza única.',                tag:'Limited', story:'Diseñado en colaboración con la joyera artesanal Mía Ferrer de Ibiza.', cat:'accessory' },
  { id:15, name:'Sol Leather Sandal',    price:'195,00 €', raw:195,  color:'Tan',          colors:['#c8a882','#1a1a1a'],           img:'pr-sandal', desc:'Sandalia de cuero curtido al vegetal con suela de esparto. Comodidad artesanal para el verano.', tag:'New', story:'Fabricadas a mano en un taller familiar de Menorca con cuero de curtido lento.', cat:'accessory' },
  { id:16, name:'Tramuntana Cap',        price:'42,00 €',  raw:42,   color:'Off-White',    colors:['#f4f2ef','#303331'],           img:'pr-cap',    desc:'Gorra de algodón orgánico no estructurada con bordado BLOOMA MDT en tono sobre tono.',         tag:null,    story:'Bordada en Barcelona con hilo de algodón orgánico.', cat:'accessory' },
];

/* ── Datos: Artículos ── */
const ARTICLES = [
  { id:1, title:'SS/25 Waverider', tag:'Campaign', date:'Mar 12, 2025', img:'jp-aw25a',
    excerpt:'Explorando las calas escondidas de las Islas Baleares para nuestra última campaña de temporada…',
    content:`<p>El amanecer sobre Cala d'Hort tiene un color que no existe en ninguna paleta Pantone. Es un naranja quemado que se convierte en rosa y luego en dorado, todo en cuestión de minutos. Es ahí donde comenzó Waverider.</p><h3>El concepto</h3><p>Para la colección SS/25, queríamos capturar esa sensación específica de estar al borde del agua sin destino: libre, presente, sin reloj. Cada prenda fue diseñada para moverse con el cuerpo, nunca contra él.</p><p>El lino orgánico que protagoniza la colección proviene de campos certificados en Bélgica, trabajado luego por tejedores portugueses que llevan tres generaciones perfeccionando el tejido de alta gramaje y baja torsión.</p><h3>La campaña</h3><p>Las imágenes fueron capturadas durante tres días en la costa oeste de Ibiza, con luz natural exclusivamente. Trabajamos con la fotógrafa Marina Ferrer, cuyo ojo para la luz dorada del atardecer ibicenco es inigualable.</p><p>El resultado es una colección que huele a sal, suena a silencio, y sienta como una segunda piel.</p>` },
  { id:2, title:'Spring/25 Lookbook', tag:'Lookbook', date:'Feb 28, 2025', img:'jp-lookbook',
    excerpt:'Un primer vistazo a las texturas y siluetas que definen nuestros próximos drops de primavera.',
    content:`<p>La primavera en Ibiza no llega de golpe. Avanza despacio, con las primeras flores de almendro en enero y los primeros días de calor real en abril. Esa transición lenta es exactamente lo que queríamos capturar en el lookbook SS/25.</p><h3>Texturas y siluetas</h3><p>Este año apostamos por el contraste entre lo estructurado y lo fluido. Prendas de corte limpio y arquitectónico que conviven con otras completamente libres y en movimiento. Es una conversación entre la geometría y la naturaleza.</p><p>La paleta de color habla el idioma del Mediterráneo: arena mojada, salvia, arcilla, y el blanco cegador de las paredes encaladas de Ibiza.</p><h3>El equipo</h3><p>El lookbook fue producido íntegramente en la isla, con un equipo local de doce personas. Maquillaje sin filtros, cabello natural, piel real. La autenticidad como filosofía de producción.</p>` },
  { id:3, title:'De Sol Capsule', tag:'Capsule', date:'Feb 10, 2025', img:'jp-desol',
    excerpt:'Una cápsula que celebra el sol y la comunidad que se reúne en Las Dalias cada semana.',
    content:`<p>Las Dalias de San Carlos es mucho más que un mercado. Es un ecosistema vivo donde artistas, diseñadores, viajeros y locales se encuentran cada semana bajo las buganvillas. Blooma nació ahí, y a ese origen regresamos con De Sol.</p><h3>La cápsula</h3><p>Doce piezas diseñadas para vivirse en Las Dalias y más allá. Tops de lino con bordados a mano, faldas con vuelo y movimiento, sandalias planas de cuero vegano. Todo en una paleta que homenajea el mercado: tierra, flores, sol.</p><p>Cada prenda de la cápsula viene con un pequeño sello de artesano, que indica quién la hizo y dónde. Porque las historias detrás de los objetos son tan valiosas como los propios objetos.</p><h3>Colaboración</h3><p>Para De Sol colaboramos con cinco artesanas ibicencas que aportan bordados y detalles únicos a cada pieza. Una parte de los beneficios regresa directamente a su taller.</p>` },
  { id:4, title:'Poolside \'25', tag:'Lifestyle', date:'Jan 25, 2025', img:'jp-pool',
    excerpt:'Nuestra visión del lujo junto a la piscina: sin ostentación, con mucha intención.',
    content:`<p>El lujo verdadero no grita. No tiene logotipos grandes ni brillantes. El lujo verdadero es una tumbona bajo un olivo antiguo, un libro, una pieza de ropa que se siente como nada sobre la piel.</p><h3>Poolside como filosofía</h3><p>Poolside '25 es nuestra respuesta a la cultura del beachwear de lujo que domina el verano mediterráneo. No queremos imitar a las grandes casas; queremos crear algo diferente: prendas funcionales que sean también objetos bellos.</p><p>El bañador de una pieza en punto de crochet hecho a mano, el pareo de seda salvaje, el kaftan de lino con tinte natural índigo. Cada pieza tiene horas de trabajo artesanal invisible que solo el tacto puede revelar.</p>` },
  { id:5, title:'HS//25 Lookbook', tag:'Lookbook', date:'Jan 15, 2025', img:'jp-hs25',
    excerpt:'Holiday season con la elegancia silenciosa que define el ADN de Blooma.',
    content:`<p>La temporada de festividades en Blooma no significa lentejuelas ni terciopelo rojo. Significa los mejores materiales que hemos seleccionado durante el año, en siluetas que funcionan tanto en una cena especial como en un paseo por el mercado.</p><h3>Piezas clave</h3><p>El blazer de lana virgen ecológica, el vestido midi de seda de punto, el pantalón de talle alto en crepé de viscosa reciclada. Piezas que duran más allá de la temporada que las vio nacer.</p><p>El lookbook fue fotografiado en Can Lluc, una finca del siglo XVII restaurada en el interior de Ibiza. La arquitectura traditional ibicenca como escenario perfecto para prendas atemporales.</p>` },
  { id:6, title:'SS25 – Sunseeker Capsule', tag:'Capsule', date:'Dec 20, 2024', img:'jp-ss25',
    excerpt:'La cápsula más pequeña que hemos hecho. Solo seis piezas. Las mejores de la temporada.',
    content:`<p>A veces menos es más. Sunseeker es un experimento en restricción creativa: ¿qué pasaría si nos obligáramos a editar la colección a solo seis piezas? ¿Cuáles sobrevivirían?</p><h3>Las seis piezas</h3><p>El resultado es una cápsula de seis prendas que representan lo mejor de nuestra producción SS/25. Un vestido halter, un pantalón ancho, una camisa de lino, un bikini top, un short de baño y un bolso de raffia. Seis piezas que se combinan entre sí de 24 maneras diferentes.</p><p>La cápsula estará disponible en tirada limitada de 200 unidades por referencia. Una vez agotadas, no volveremos a producirlas.</p><h3>El nombre</h3><p>Sunseeker es el nombre que los ibicencos dan a los turistas que cada verano llegan buscando el sol. Pero también somos todos nosotros, persiguiendo esa luz que hace que todo parezca más simple y más hermoso.</p>` },
];

/* ── Estado ── */
let cart = [];
let currentProductId = null;

/* ── Navegación ── */
function go(page) {
  document.querySelectorAll('.page').forEach(p => p.classList.remove('active'));
  document.getElementById('page-' + page).classList.add('active');
  window.scrollTo(0, 0);
}

function goCollection(tag) {
  go('collection');
  // Activar el filtro correcto
  const tabs = document.querySelectorAll('.filter-tab');
  tabs.forEach(t => t.classList.remove('active'));
  if (tag) {
    const labels = { 'New':'New In', 'Bestseller':'Bestsellers', 'Limited':'Limited' };
    tabs.forEach(t => { if (t.textContent === labels[tag]) t.classList.add('active'); });
  } else {
    tabs[0].classList.add('active');
  }
  renderCollectionGrid(tag);
}

function openMenu()  { document.getElementById('mobMenu').classList.add('open'); }
function closeMenu() { document.getElementById('mobMenu').classList.remove('open'); }

/* ── Menú móvil — desplegables ── */
function toggleMobSub(btn) {
  var sub = btn.nextElementSibling;
  var expanded = btn.getAttribute('aria-expanded') === 'true';
  btn.setAttribute('aria-expanded', !expanded);
  sub.classList.toggle('open');
}

/* ── Mega menu ── */
let _megaT;
function showMega() {
  clearTimeout(_megaT);
  /* Cierra Drops si estaba abierto */
  document.getElementById('dropsMenu').classList.remove('open');
  document.getElementById('megaMenu').classList.add('open');
}
function hideMega() {
  _megaT = setTimeout(() => document.getElementById('megaMenu').classList.remove('open'), 120);
}
function keepMega() { clearTimeout(_megaT); }

/* ── Mega menu Drops ── */
let _dropsT;
function showDropsMega() {
  clearTimeout(_dropsT);
  /* Cierra Shop si estaba abierto */
  document.getElementById('megaMenu').classList.remove('open');
  document.getElementById('dropsMenu').classList.add('open');
}
function hideDropsMega() {
  _dropsT = setTimeout(() => document.getElementById('dropsMenu').classList.remove('open'), 120);
}
function keepDropsMega() { clearTimeout(_dropsT); }

/* ── Search ── */
function openSearch() {
  document.getElementById('searchOverlay').classList.add('open');
  setTimeout(() => document.getElementById('searchInput').focus(), 80);
}
function closeSearch() {
  document.getElementById('searchOverlay').classList.remove('open');
  document.getElementById('searchInput').value = '';
}
function runSearch(e) {
  if (e.key !== 'Enter') return;
  const q = e.target.value.trim().toLowerCase();
  if (!q) return;
  closeSearch();
  go('collection');
  const filtered = PRODUCTS.filter(p =>
    p.name.toLowerCase().includes(q) || p.color.toLowerCase().includes(q)
  );
  const cg = document.getElementById('collGrid');
  if (filtered.length === 0) {
    cg.innerHTML = '<p style="padding:4rem;grid-column:1/-1;text-align:center;font-size:13px;color:var(--on-surface-var);">No se encontraron resultados para "' + q + '".</p>';
    document.getElementById('filterCount').textContent = '0 results';
  } else {
    cg.innerHTML = filtered.map(collCardHtml).join('');
    document.getElementById('filterCount').textContent = 'Showing ' + filtered.length + ' piece' + (filtered.length > 1 ? 's' : '');
  }
  document.querySelectorAll('.filter-tab').forEach(t => t.classList.remove('active'));
}

/* ── Render helpers ── */
function colorDots(colors) {
  return colors.map(c => `<div class="cdot" style="background:${c};"></div>`).join('');
}

function prodCardHtml(p) {
  const tag = p.tag ? `<div class="prod-card__tag">${p.tag}</div>` : '';
  return `
    <div class="prod-card" onclick="openProduct(${p.id})">
      <div class="prod-card__img-wrap">
        ${tag}
        <img class="prod-card__img" src="https://picsum.photos/seed/${p.img}/400/533" alt="${p.name}" loading="lazy">
      </div>
      <p class="prod-card__name">${p.name}</p>
      <p class="prod-card__price">${p.price}</p>
      <div class="prod-card__colors">${colorDots(p.colors)}</div>
    </div>`;
}

function collCardHtml(p) {
  const newBadge   = p.tag === 'New'        ? '<span class="coll-card__badge">New</span>' : '';
  const otherBadge = p.tag && p.tag !== 'New' ? `<span class="coll-card__badge">${p.tag}</span>` : '';
  const badges     = (newBadge || otherBadge) ? `<div class="coll-card__badges">${newBadge}${otherBadge}</div>` : '';
  return `
    <div class="coll-card" onclick="openProduct(${p.id})">
      <div class="coll-card__img-wrap">
        <img class="coll-card__img" src="https://picsum.photos/seed/${p.img}/400/533" alt="${p.name}" loading="lazy">
        ${badges}
        <button class="coll-card__quick" onclick="event.stopPropagation();quickAdd(${p.id})">Quick Add</button>
      </div>
      <div class="coll-card__body">
        <div class="coll-card__row">
          <span class="coll-card__name">${p.name}</span>
          <span class="coll-card__price">${p.price}</span>
        </div>
        <p class="coll-card__sizes">S / M / L / XL</p>
      </div>
    </div>`;
}

function renderCollectionGrid(tag) {
  /* Desactivado: los productos vienen de Shopify (Liquid). No sobrescribir el grid. */
  return;
}

function initGrids() {
  /* Desactivado: todos los grids (home, colección, new in, drops, journal, accesorios)
     se renderizan ahora desde Shopify Liquid con productos reales. */
  return;
}

/* ── New In ── */
function renderNewIn() { /* Desactivado: New In viene de Shopify (Liquid). */ return; }

/* ── Accessories ── */
function renderAccessories(subcat) { /* Desactivado: accesorios vienen de Shopify (Liquid). */ return; }

function filterAccessories(subcat) {
  /* Scroll al grid de productos */
  const grid = document.getElementById('accGrid');
  if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

/* ── Drops thumbnails ── */
function renderDropsThumbs() { /* Desactivado: thumbs vienen de Shopify (Liquid). */ return; }

/* ── Journal ── */
function renderJournal() { /* Desactivado: journal viene de Shopify (Liquid). */ return; }

function openArticle(id) {
  const a = ARTICLES.find(x => x.id === id);
  if (!a) return;
  document.getElementById('articleImg').src    = 'https://picsum.photos/seed/' + a.img + '/1600/900';
  document.getElementById('articleImg').alt    = a.title;
  document.getElementById('articleTag').textContent   = a.tag;
  document.getElementById('articleDate').textContent  = a.date;
  document.getElementById('articleTitle').textContent = a.title;
  document.getElementById('articleBreadcrumb').textContent = a.title;
  document.getElementById('articleBody').innerHTML    = a.content;

  /* Más artículos (todos menos el actual) */
  const more = ARTICLES.filter(x => x.id !== id).slice(0, 3);
  document.getElementById('moreArticlesGrid').innerHTML = more.map(m => `
    <article class="jp-card" onclick="openArticle(${m.id})">
      <div class="jp-card__wrap">
        <img src="https://picsum.photos/seed/${m.img}/600/340" alt="${m.title}" loading="lazy">
      </div>
      <p class="jp-card__tag">${m.tag}</p>
      <h2 class="jp-card__title">${m.title}</h2>
      <p class="jp-card__date">${m.date}</p>
    </article>`).join('');

  go('article');
}

/* ── Producto ── */
function openProduct(id) {
  const p = PRODUCTS.find(x => x.id === id);
  if (!p) return;
  currentProductId = id;

  document.getElementById('prodName').textContent  = p.name.toUpperCase();
  document.getElementById('prodPrice').textContent = p.price;
  document.getElementById('prodDesc').textContent  = p.desc;
  document.getElementById('colorLabel').textContent = 'Color: ' + p.color;
  document.getElementById('prodBreadcrumb').textContent = p.name;
  document.getElementById('prodStoryContent').innerHTML = '<p>' + p.story + '</p>';

  /* Imágenes dinámicas */
  const seeds = ['', 'b', 'c', 'd', 'e', 'f'];
  document.getElementById('prodImgs').innerHTML = seeds.map((s, i) => `
    <div class="prod-img-blk">
      <img src="https://picsum.photos/seed/${p.img}${['','b','c','d','e','f'][i]}/600/800" alt="${p.name}" loading="${i === 0 ? 'eager' : 'lazy'}">
    </div>`).join('');

  /* Colores dinámicos */
  document.getElementById('prodColorSel').innerHTML = p.colors.map((c, i) => `
    <button class="color-btn${i === 0 ? ' sel' : ''}" onclick="pickColor(this,'${i === 0 ? p.color : 'Variante ' + (i+1)}')">
      <div class="color-btn__in" style="background:${c};border:${c === '#f4f2ef' || c === '#f8f6f3' ? '1px solid #ddd' : 'none'};"></div>
    </button>`).join('');

  /* Reset talla */
  document.querySelectorAll('.size-btn').forEach((b, i) => {
    b.classList.toggle('sel', i === 1);
  });

  /* Relacionados */
  const related = PRODUCTS.filter(x => x.id !== id).slice(0, 3);
  document.getElementById('relatedGrid').innerHTML = related.map(r => `
    <div style="cursor:pointer;" onclick="openProduct(${r.id})">
      <div style="aspect-ratio:3/4;overflow:hidden;background:var(--surface-low);margin-bottom:.5rem;">
        <img src="https://picsum.photos/seed/${r.img}/300/400" alt="${r.name}" loading="lazy" style="width:100%;height:100%;object-fit:cover;transition:transform .5s ease;">
      </div>
      <p style="font-size:10px;letter-spacing:.1em;text-transform:uppercase;">${r.name}</p>
      <p style="font-size:12px;font-weight:500;">${r.price}</p>
    </div>`).join('');

  go('product');
}

function pickColor(btn, name) {
  document.querySelectorAll('.color-btn').forEach(b => b.classList.remove('sel'));
  btn.classList.add('sel');
  document.getElementById('colorLabel').textContent = 'Color: ' + name;
}

function pickSize(btn) {
  document.querySelectorAll('.size-btn').forEach(b => b.classList.remove('sel'));
  btn.classList.add('sel');
}

/* ── Carrito ── */
function addToCart() {
  const p = PRODUCTS.find(x => x.id === currentProductId);
  const name  = document.getElementById('prodName').textContent;
  const price = document.getElementById('prodPrice').textContent;
  const color = document.getElementById('colorLabel').textContent.replace('Color: ', '');
  const sizeEl = document.querySelector('.size-btn.sel');
  const size  = sizeEl ? sizeEl.textContent : 'M';
  const img   = p ? 'https://picsum.photos/seed/' + p.img + '/200/267' : '';
  pushCart({ name, price, color, size, img });
}

function quickAdd(id) {
  const p = PRODUCTS.find(x => x.id === id);
  if (p) pushCart({ name: p.name, price: p.price, color: p.color, size: 'M', img: 'https://picsum.photos/seed/' + p.img + '/200/267' });
}

function pushCart(item) {
  cart.push(item);
  renderCart();
  showToast('¡Añadido al carrito!');
}

function removeItem(i) { cart.splice(i, 1); renderCart(); }

function renderCart() {
  const count = cart.length;
  document.getElementById('cartCount').textContent = count > 0 ? '(' + count + ')' : '';
  const items = document.getElementById('cartItems');
  const empty = document.getElementById('cartEmpty');
  const foot  = document.getElementById('cartFoot');

  if (count === 0) {
    items.innerHTML = '';
    items.appendChild(empty);
    empty.style.display = 'block';
    foot.style.display  = 'none';
    return;
  }

  empty.style.display = 'none';
  foot.style.display  = 'block';

  let total = 0;
  let html  = '';
  cart.forEach((item, i) => {
    const raw = parseFloat(item.price.replace(',', '.').replace(/\s?€/, ''));
    total += isNaN(raw) ? 0 : raw;
    html += `
      <div class="cart-item">
        <img src="${item.img}" alt="${item.name}">
        <div class="cart-item__info">
          <p class="cart-item__name">${item.name}</p>
          <p class="cart-item__detail">${item.color} · Talla ${item.size}</p>
        </div>
        <div class="cart-item__right">
          <button class="cart-item__rm" onclick="removeItem(${i})" aria-label="Eliminar">×</button>
          <span class="cart-item__price">${item.price}</span>
        </div>
      </div>`;
  });
  items.innerHTML = html;
  document.getElementById('cartTotal').textContent = total.toFixed(2).replace('.', ',') + '\u202f€';
}

function toggleCart() {
  document.getElementById('cartOverlay').classList.toggle('open');
  document.getElementById('cartSidebar').classList.toggle('open');
}

/* ── Filtros ── */
function setFilter(btn, tag) {
  document.querySelectorAll('.filter-tab').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  renderCollectionGrid(tag);
}

/* ── Accordion ── */
function toggleAcc(trigger) {
  const content = trigger.nextElementSibling;
  const icon    = trigger.querySelector('.material-symbols-outlined');
  const isOpen  = content.classList.contains('open');
  document.querySelectorAll('.acc-content').forEach(c => c.classList.remove('open'));
  document.querySelectorAll('.acc-trigger .material-symbols-outlined').forEach(i => { i.textContent = 'add'; });
  if (!isOpen) { content.classList.add('open'); icon.textContent = 'remove'; }
}

/* ── Newsletter ── */
function subscribeNewsletter(form) {
  const input = form.querySelector('input[type="email"]');
  if (!input || !input.value.includes('@')) { if (input) input.focus(); return; }
  form.innerHTML = '<p class="newsletter__success">✓ Suscrito. Gracias por unirte a Blooma.</p>';
}

/* ── Toast ── */
function showToast(msg) {
  const t = document.getElementById('toast');
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(() => t.classList.remove('show'), 2600);
}

/* ── Banner rotation ── */
(function() {
  const msgs = document.querySelectorAll('.banner__msg');
  if (msgs.length <= 1) return;
  let cur = 0;
  setInterval(() => {
    msgs[cur].classList.remove('active');
    cur = (cur + 1) % msgs.length;
    msgs[cur].classList.add('active');
  }, 4000);
})();

/* ── Efectos de scroll ── */
function initScrollFX() {
  /* IntersectionObserver: fade + slide al entrar en viewport */
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('fx-in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.06 });

  /* Secciones de la home */
  ['.categories', '.sale-banner', '.top-picks', '.philosophy', '.journal-sec', '.newsletter']
    .forEach(sel => {
      const el = document.querySelector('#page-home ' + sel);
      if (el) { el.classList.add('fx-rise'); io.observe(el); }
    });

  /* J-cards del home con stagger */
  document.querySelectorAll('#page-home .j-card').forEach((el, i) => {
    el.classList.add('fx-rise');
    el.style.transitionDelay = i * 0.1 + 's';
    io.observe(el);
  });

  /* Tarjetas de top picks con stagger */
  document.querySelectorAll('#topPicksGrid .prod-card').forEach((el, i) => {
    el.classList.add('fx-rise');
    el.style.transitionDelay = Math.min(i * 0.07, 0.42) + 's';
    io.observe(el);
  });

  /* Parallax ligero + fade del texto del hero al scroll */
  const heroEl   = document.querySelector('.hero');
  const heroOver = document.querySelector('.hero__over');
  const heroImg  = document.querySelector('.hero img');
  if (!heroEl) return;

  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    const h = heroEl.offsetHeight;

    /* Parallax: imagen sube más despacio → sensación de profundidad */
    if (heroImg) heroImg.style.transform = `translateY(${y * 0.18}px)`;

    /* Fade del texto cuando el usuario empieza a bajar */
    if (heroOver) heroOver.style.opacity = Math.max(0, 1 - y / (h * 0.45));
  }, { passive: true });
}

/* ── Init ── */
initGrids();
initScrollFX();
